import React from "react";
import { useLocale } from "hooks";
import clsx from "clsx";

const Search = ({
  onSearch,
  register
}) => {
  const { isRTL, isFA } = useLocale();
  return (
    <form
      className="tw-relative tw-grid tw-grid-cols-1 md:tw-grid-cols-3 lg:tw-grid-cols-4 tw-gap-4"
      onSubmit={onSearch}
    // onSubmit={handleSubmit(onSubmit)}
    >

      <input
        className={clsx(
          "tw-bg-[white] tw-text-sm tw-font-medium tw-rounded-lg tw-border tw-border-[#344456]/20 tw-py-3.5 focus-visible:!tw-border focus-visible:!tw-border-solid focus-visible:!tw-border-[#344456]/20 tw-w-full placeholder:tw-text-[#344456]/30",
          { "tw-pl-10 tw-pr-4": isRTL, "tw-pr-10 tw-pl-4 ltr": !isRTL }
        )}
        placeholder={isFA ? "نام" : "First Name"}
        {...register("firstName")}

      />

      <input
        className={clsx(
          "tw-bg-[white] tw-text-sm tw-font-medium tw-rounded-lg tw-border tw-border-[#344456]/20 tw-py-3.5 focus-visible:!tw-border focus-visible:!tw-border-solid focus-visible:!tw-border-[#344456]/20 tw-w-full placeholder:tw-text-[#344456]/30",
          { "tw-pl-10 tw-pr-4": isRTL, "tw-pr-10 tw-pl-4 ltr": !isRTL }
        )}
        placeholder={isFA ? "نام خانوادگی" : "Last Name"}
        {...register("lastName")}

      />
      <div>
      <button
        type="submit"
        className={clsx(
          "tw-border-0 tw-cursor-pointer tw-bg-[#004883] hover:tw-bg-[#004883]/80 tw-rounded-md tw-flex tw-items-center tw-justify-center tw-p-3.5 tw-w-full md:tw-w-[unset]",
        )}
      >
        <svg
          width="17"
          height="18"
          viewBox="0 0 17 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.9225 15.9108L13.8542 12.8425C14.8817 11.5583 15.5 9.93413 15.5 8.16663C15.5 4.03079 12.135 0.666626 8 0.666626C3.865 0.666626 0.5 4.03079 0.5 8.16663C0.5 12.3025 3.865 15.6666 8 15.6666C9.76833 15.6666 11.3925 15.0483 12.6758 14.0216L15.7442 17.0891L16.9225 15.9108ZM8 14C4.78333 14 2.16667 11.3833 2.16667 8.16663C2.16667 4.95079 4.78333 2.33329 8 2.33329C11.2167 2.33329 13.8333 4.95079 13.8333 8.16663C13.8333 11.3833 11.2167 14 8 14Z"
            fill="white"
          />
        </svg>
      </button>
      </div>
      
    </form>
  );
};

export default Search;
